import { ReactElement } from "react";

export enum MessageType {
  Text = "text",
  Question = "question",
  Explanation = "explanation",
}

export enum MessageAuthor {
  Bot = "assistant",
  User = "user",
}

export function fromName(str: string): MessageAuthor {
  switch (str) {
    case "assistant":
      return MessageAuthor.Bot;
    case "user":
      return MessageAuthor.User;
  }
  throw Error("unrecognised message author");
}

export type Message = {
  id: string;
  author: MessageAuthor;
  profileImageUrl?: string;
  type: MessageType;
  question?: string;
  text?: string | ReactElement;
  sentAt: string;
  widget?: ReactElement | null;
};

export type PushMessage = Omit<Message, "id" | "type" | "sentAt">;
export type UpdateMessage = Omit<
  Message,
  "type" | "sentAt" | "author" | "profileImageUrl" | "minTypingTimeMs"
>;
